import React from 'react';
interface Section {
  heading: string;
  content: React.ReactNode;
}
const intro = 'En Real en línea, respetamos tu privacidad y estamos comprometidos con la protección de tus datos personales. Esta Política de Privacidad explica cómo recopilamos, usamos, almacenamos y protegemos tu información cuando visitas nuestro sitio web, interactúas con nuestras páginas, anuncios, formularios o realizas una compra de nuestros productos o servicios.';
const sections: Section[] = [{
  heading: '1. Información que recopilamos',
  content: <>
        <p data-id="element-1">Podemos recopilar información personal cuando:</p>
        <ul className="list-disc pl-6 space-y-1.5 mt-3" data-id="element-2">
          <li data-id="element-3">visitas nuestro sitio web,</li>
          <li data-id="element-4">completas formularios,</li>
          <li data-id="element-5">solicitas información,</li>
          <li data-id="element-6">te registras para recibir contenido,</li>
          <li data-id="element-7">
            interactúas con nuestros anuncios en Facebook, Instagram u otras
            plataformas,
          </li>
          <li data-id="element-8">realizas una compra,</li>
          <li data-id="element-9">
            o te comunicas con nosotros por correo electrónico, redes sociales,
            WhatsApp u otros medios.
          </li>
        </ul>
        <p className="mt-4" data-id="element-10">La información recopilada puede incluir:</p>
        <ul className="list-disc pl-6 space-y-1.5 mt-3" data-id="element-11">
          <li data-id="element-12">nombre y apellidos,</li>
          <li data-id="element-13">dirección de correo electrónico,</li>
          <li data-id="element-14">número de teléfono,</li>
          <li data-id="element-15">país o ciudad,</li>
          <li data-id="element-16">dirección IP,</li>
          <li data-id="element-17">información de navegación,</li>
          <li data-id="element-18">
            datos relacionados con compras, pagos o interés en nuestros
            productos o servicios.
          </li>
        </ul>
      </>
}, {
  heading: '2. Cómo utilizamos tu información',
  content: <>
        <p data-id="element-19">Utilizamos la información recopilada para:</p>
        <ul className="list-disc pl-6 space-y-1.5 mt-3" data-id="element-20">
          <li data-id="element-21">responder a tus consultas o solicitudes,</li>
          <li data-id="element-22">
            enviarte información sobre productos, servicios, promociones o
            contenidos,
          </li>
          <li data-id="element-23">procesar compras y pagos,</li>
          <li data-id="element-24">gestionar el acceso a productos digitales,</li>
          <li data-id="element-25">
            mejorar nuestro sitio web, campañas, contenidos y experiencia del
            usuario,
          </li>
          <li data-id="element-26">analizar resultados publicitarios,</li>
          <li data-id="element-27">personalizar anuncios y comunicaciones,</li>
          <li data-id="element-28">cumplir obligaciones legales o contractuales.</li>
        </ul>
      </>
}, {
  heading: '3. Cookies y tecnologías de seguimiento',
  content: <>
        <p data-id="element-29">
          Nuestro sitio web puede utilizar cookies, píxeles, etiquetas y
          tecnologías similares para mejorar la experiencia del usuario,
          analizar la navegación y medir el rendimiento de nuestras campañas
          publicitarias.
        </p>
        <p className="mt-4" data-id="element-30">Esto puede incluir herramientas como:</p>
        <ul className="list-disc pl-6 space-y-1.5 mt-3" data-id="element-31">
          <li data-id="element-32">Meta Pixel (antes Facebook Pixel)</li>
          <li data-id="element-33">cookies del navegador</li>
          <li data-id="element-34">herramientas de analítica</li>
          <li data-id="element-35">tecnologías de seguimiento de conversiones</li>
        </ul>
        <p className="mt-4" data-id="element-36">
          Estas herramientas pueden recopilar información como:
        </p>
        <ul className="list-disc pl-6 space-y-1.5 mt-3" data-id="element-37">
          <li data-id="element-38">páginas visitadas,</li>
          <li data-id="element-39">tiempo de navegación,</li>
          <li data-id="element-40">acciones realizadas dentro del sitio,</li>
          <li data-id="element-41">tipo de dispositivo,</li>
          <li data-id="element-42">navegador utilizado,</li>
          <li data-id="element-43">dirección IP,</li>
          <li data-id="element-44">interacciones con anuncios o formularios.</li>
        </ul>
      </>
}, {
  heading: '4. Publicidad y remarketing',
  content: <>
        <p data-id="element-45">
          Podemos utilizar la información recopilada para mostrar anuncios
          personalizados o realizar campañas de remarketing en plataformas como
          Facebook, Instagram u otras redes publicitarias.
        </p>
        <p className="mt-4" data-id="element-46">
          Esto nos permite medir resultados, optimizar campañas y ofrecer
          contenido más relevante a nuestros usuarios.
        </p>
      </>
}, {
  heading: '5. Procesamiento de pagos y terceros',
  content: <>
        <p data-id="element-47">
          Algunas compras o registros pueden procesarse a través de plataformas
          de terceros, incluyendo, pero no limitado a, Hotmart y otras
          herramientas tecnológicas utilizadas para pagos, automatización,
          analítica, email marketing, alojamiento web o publicidad digital.
        </p>
        <p className="mt-4" data-id="element-48">
          Estas plataformas pueden recopilar y procesar cierta información de
          acuerdo con sus propios términos y políticas de privacidad.
        </p>
      </>
}, {
  heading: '6. Compartición de información',
  content: <p data-id="element-49">
        En Real en línea no vendemos, alquilamos ni comercializamos tus datos
        personales. Sin embargo, podemos compartir información con proveedores o
        servicios de terceros que nos ayudan a operar el sitio web, procesar
        pagos, entregar productos, analizar métricas o ejecutar campañas
        publicitarias, siempre dentro de lo necesario para el funcionamiento del
        negocio.
      </p>
}, {
  heading: '7. Conservación de los datos',
  content: <p data-id="element-50">
        Conservaremos tu información personal durante el tiempo que sea
        necesario para cumplir con los fines descritos en esta Política de
        Privacidad, salvo que la ley exija o permita un periodo mayor.
      </p>
}, {
  heading: '8. Seguridad de la información',
  content: <p data-id="element-51">
        Tomamos medidas razonables de seguridad para proteger tu información
        frente a pérdida, uso indebido, acceso no autorizado, alteración o
        divulgación. Sin embargo, ningún sistema de transmisión o almacenamiento
        de datos en internet es completamente seguro, por lo que no podemos
        garantizar una seguridad absoluta.
      </p>
}, {
  heading: '9. Tus derechos',
  content: <>
        <p data-id="element-52">Dependiendo de tu país o jurisdicción, puedes tener derecho a:</p>
        <ul className="list-disc pl-6 space-y-1.5 mt-3" data-id="element-53">
          <li data-id="element-54">acceder a tus datos personales,</li>
          <li data-id="element-55">solicitar la corrección de información inexacta,</li>
          <li data-id="element-56">solicitar la eliminación de tus datos,</li>
          <li data-id="element-57">oponerte a determinados usos de tu información,</li>
          <li data-id="element-58">retirar tu consentimiento cuando sea aplicable.</li>
        </ul>
        <p className="mt-4" data-id="element-59">
          Si deseas ejercer cualquiera de estos derechos, puedes contactarnos a
          través del correo indicado al final de esta política.
        </p>
      </>
}, {
  heading: '10. Enlaces a sitios externos',
  content: <p data-id="element-60">
        Nuestro sitio web puede contener enlaces a sitios web de terceros. No
        somos responsables por las políticas de privacidad, contenidos o
        prácticas de dichos sitios externos.
      </p>
}, {
  heading: '11. Cambios a esta política',
  content: <p data-id="element-61">
        Nos reservamos el derecho de actualizar o modificar esta Política de
        Privacidad en cualquier momento. Cualquier cambio será publicado en esta
        misma página y entrará en vigor desde su fecha de publicación.
      </p>
}, {
  heading: '12. Contacto',
  content: <>
        <p data-id="element-62">
          Si tienes preguntas sobre esta Política de Privacidad o sobre el
          tratamiento de tus datos, puedes contactarnos en:
        </p>
        <dl className="mt-4 space-y-2" data-id="element-63">
          <div className="flex flex-col sm:flex-row sm:gap-2" data-id="element-64">
            <dt className="font-medium text-neutral-900 sm:w-40" data-id="element-65">Marca:</dt>
            <dd data-id="element-66">Real en línea</dd>
          </div>
          <div className="flex flex-col sm:flex-row sm:gap-2" data-id="element-67">
            <dt className="font-medium text-neutral-900 sm:w-40" data-id="element-68">Sitio web:</dt>
            <dd data-id="element-69">realenlinea.com</dd>
          </div>
          <div className="flex flex-col sm:flex-row sm:gap-2" data-id="element-70">
            <dt className="font-medium text-neutral-900 sm:w-40" data-id="element-71">
              Correo electrónico:
            </dt>
            <dd data-id="element-72">
              <a href="mailto:realenlinea1@gmail.com" className="underline underline-offset-2 hover:text-neutral-900 transition-colors" data-id="element-73">
                realenlinea1@gmail.com
              </a>
            </dd>
          </div>
        </dl>
      </>
}];
export function PrivacyPolicy() {
  return <div className="w-full min-h-screen bg-white text-neutral-900 flex flex-col" data-id="element-74">
      <header className="border-b border-neutral-200" data-id="element-75">
        <div className="max-w-3xl mx-auto px-6 py-6 flex items-center justify-between" data-id="element-76">
          <a href="/" className="text-lg font-semibold tracking-tight" data-id="element-77">
            Real en línea
          </a>
          <nav className="text-sm text-neutral-600" data-id="element-78">
            <a href="/" className="hover:text-neutral-900 transition-colors" data-id="element-79">
              Inicio
            </a>
          </nav>
        </div>
      </header>

      <main className="flex-1" data-id="element-80">
        <article className="max-w-3xl mx-auto px-6 py-16" data-id="element-81">
          <div className="mb-12" data-id="element-82">
            <p className="text-sm uppercase tracking-wider text-neutral-500 mb-3" data-id="element-83">
              Legal
            </p>
            <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight mb-4" data-id="element-84">
              Política de Privacidad
            </h1>
            <p className="text-neutral-600" data-id="element-85">
              Última actualización: 10 de mayo de 2026
            </p>
          </div>

          <section className="mb-12" data-id="element-86">
            <p className="text-neutral-700 leading-relaxed" data-id="element-87">{intro}</p>
          </section>

          <div className="space-y-12" data-id="element-88">
            {sections.map(section => <section key={section.heading} data-id="element-89">
                <h2 className="text-xl font-semibold tracking-tight mb-4" data-id="element-90">
                  {section.heading}
                </h2>
                <div className="text-neutral-700 leading-relaxed space-y-2" data-id="element-91">
                  {section.content}
                </div>
              </section>)}
          </div>
        </article>
      </main>

      <footer className="border-t border-neutral-200" data-id="element-92">
        <div className="max-w-3xl mx-auto px-6 py-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-sm text-neutral-600" data-id="element-93">
          <p data-id="element-94">
            © {new Date().getFullYear()} Real en línea. Todos los derechos
            reservados.
          </p>
          <div className="flex gap-6" data-id="element-95">
            <a href="/" className="hover:text-neutral-900 transition-colors" data-id="element-96">
              Inicio
            </a>
            <a href="/privacidad" className="hover:text-neutral-900 transition-colors" data-id="element-97">
              Privacidad
            </a>
          </div>
        </div>
      </footer>
    </div>;
}